export type WarningProps = {
  className?: string
}

export function Warning({ className = '' }: WarningProps) {
  return (
    <div
      className={`bg-mauvelous rounded-full w-28 h-28 flex justify-center items-center ${className}`}
    >
      <span aria-hidden='true' className='lm__font--100 font-extrabold'>
        {'!'}
      </span>
    </div>
  )
}
